import { ReactNode } from 'react';
import { X, ArrowLeft } from 'lucide-react';

interface SettingsPanelProps {
  isDark: boolean;
  title: string;
  children: ReactNode;
  onClose: () => void;
  actions?: ReactNode;
  className?: string;
  showBackButton?: boolean;
  buttonTitle?: string;
}

export default function SettingsPanel({
  isDark,
  title,
  children,
  onClose,
  actions,
  className = '',
  showBackButton = false,
  buttonTitle,
}: SettingsPanelProps) {
  return (
    <div
      className={`${
        isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
      } shadow-sm border rounded-xl max-h-full overflow-y-auto min-w-64 ${className}`}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4 pb-2">
        <h2 className={`text-lg font-semibold ${isDark ? 'text-gray-100' : 'text-gray-900'}`}>
          {title}
        </h2>
        <button
          onClick={onClose}
          className={`w-8 h-8 rounded-md flex items-center justify-center transition-colors ${
            isDark
              ? 'hover:bg-gray-700 text-gray-400 hover:text-gray-300'
              : 'hover:bg-gray-100 text-gray-500 hover:text-gray-700'
          }`}
          title={buttonTitle || (showBackButton ? `Back to Layers` : `Close ${title}`)}
        >
          {showBackButton ? <ArrowLeft className="w-4 h-4" /> : <X className="w-4 h-4" />}
        </button>
      </div>

      {/* Content */}
      <div className="p-4 pt-2 space-y-6">{children}</div>

      {/* Footer Actions */}
      {actions && (
        <div className="p-4 pt-2 border-t border-gray-200 dark:border-gray-700">{actions}</div>
      )}
    </div>
  );
}
